import Generator from '../../../../Generator'
import Types from '../../../../../actions/Types'

export default Generator.node({
  baseType: Types.CTRL_TASKS,
  nodeType: Generator.NODETYPE.GET
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/controls/task/get.js